/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  CreateFeatureFlagDTO,
  GetFeatureFlags200,
  GetFeatureFlagsKey200,
  GetFeatureFlagsPublic200,
  PostFeatureFlagsAdmin201
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Retorna todas as feature flags resolvidas para o usuário autenticado
 * @summary Obter feature flags do usuário
 */
export type getFeatureFlagsResponse200 = {
  data: GetFeatureFlags200
  status: 200
}

export type getFeatureFlagsResponseSuccess = (getFeatureFlagsResponse200) & {
  headers: Headers;
};
;

export type getFeatureFlagsResponse = (getFeatureFlagsResponseSuccess)

export const getGetFeatureFlagsUrl = () => {


  

  return `https://api.wedofi.com/feature-flags`
}

export const getFeatureFlags = async ( options?: RequestInit): Promise<getFeatureFlagsResponse> => {
  
  return customFetch<getFeatureFlagsResponse>(getGetFeatureFlagsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna todas as feature flags globais resolvidas
 * @summary Obter feature flags públicas
 */
export type getFeatureFlagsPublicResponse200 = {
  data: GetFeatureFlagsPublic200
  status: 200
}

export type getFeatureFlagsPublicResponseSuccess = (getFeatureFlagsPublicResponse200) & {
  headers: Headers;
};
;

export type getFeatureFlagsPublicResponse = (getFeatureFlagsPublicResponseSuccess)

export const getGetFeatureFlagsPublicUrl = () => {


  

  return `https://api.wedofi.com/feature-flags/public`
}

export const getFeatureFlagsPublic = async ( options?: RequestInit): Promise<getFeatureFlagsPublicResponse> => {
  
  return customFetch<getFeatureFlagsPublicResponse>(getGetFeatureFlagsPublicUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Verifica se uma feature flag está habilitada para o usuário
 * @summary Verificar feature flag específica
 */
export type getFeatureFlagsKeyResponse200 = {
  data: GetFeatureFlagsKey200
  status: 200
}

export type getFeatureFlagsKeyResponseSuccess = (getFeatureFlagsKeyResponse200) & {
  headers: Headers;
};
;

export type getFeatureFlagsKeyResponse = (getFeatureFlagsKeyResponseSuccess)

export const getGetFeatureFlagsKeyUrl = (key: string,) => {


  

  return `https://api.wedofi.com/feature-flags/${key}`
}

export const getFeatureFlagsKey = async (key: string, options?: RequestInit): Promise<getFeatureFlagsKeyResponse> => {
  
  return customFetch<getFeatureFlagsKeyResponse>(getGetFeatureFlagsKeyUrl(key),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Cria uma nova feature flag (apenas administradores)
 * @summary Criar feature flag (admin)
 */
export type postFeatureFlagsAdminResponse201 = {
  data: PostFeatureFlagsAdmin201
  status: 201
}

export type postFeatureFlagsAdminResponseSuccess = (postFeatureFlagsAdminResponse201) & {
  headers: Headers;
};
;

export type postFeatureFlagsAdminResponse = (postFeatureFlagsAdminResponseSuccess)

export const getPostFeatureFlagsAdminUrl = () => {


  

  return `https://api.wedofi.com/feature-flags/admin`
}

export const postFeatureFlagsAdmin = async (createFeatureFlagDTO: CreateFeatureFlagDTO, options?: RequestInit): Promise<postFeatureFlagsAdminResponse> => {
  
  return customFetch<postFeatureFlagsAdminResponse>(getPostFeatureFlagsAdminUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFeatureFlagDTO,)
  }
);}
  

